// extracted by mini-css-extract-plugin
export default {"input":"Inputs_input__Zo6Jr","inputGive":"Inputs_inputGive__uShch","disabled":"Inputs_disabled__iDnfG"};